'use client'

import dynamic from 'next/dynamic'
import { ComponentProps } from 'react'
import { Skeleton } from '@ui/primitives/Skeleton'

const AudioPlayerComponent = dynamic(
  () => import('@/components/audio/AudioPlayer').then(mod => ({ default: mod.AudioPlayer })),
  {
    loading: () => (
      <div className="p-4 bg-gray-100 rounded-lg">
        <Skeleton className="h-20 w-full" />
      </div>
    ),
    ssr: false,
  }
)

export function LazyAudioPlayer(props: ComponentProps<typeof AudioPlayerComponent>) {
  return <AudioPlayerComponent {...props} />
}
